import { keepPreviousData } from '@tanstack/react-query';
import { isRedirect } from '@tanstack/react-router';
import { AGGREGATE_NAMES, CORPORATION_RESOLVERS } from 'cpool-constants';
import { schemaCorporationResolver_GetOwnCorporation } from 'cpool-tables/backend-resolvers';

import useUserInfo from '~/hooks/useUserInfo';
import { useAggregateQuery } from '~/queryUtils/useQuery.ts';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys.ts';

export const useGetOwnCorporation = () => {
    const user = useUserInfo();
    const queryKey = queryKeys.getOwnCorporation();
    const position = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.CORPORATION,
        resolverName: CORPORATION_RESOLVERS.getOwnCorporation,
        schema: schemaCorporationResolver_GetOwnCorporation,
        searchParams: {
            position,
        },
        tanstack: {
            // resolver throws for users without corporation (admins, team-less advisers)
            enabled: !!user?.corporationId,
            placeholderData: keepPreviousData,
            // the API layer throws a redirect once its own 403 renewals are used up — retrying it only delays the next identity
            retry: (failureCount, error) => !isRedirect(error) && failureCount < 3,
        },
    });
};
